'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _find2 = require('lodash/find');

var _find3 = _interopRequireDefault(_find2);

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _desc, _value, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5;

var _mobx = require('mobx');

var _utils = require('../utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  Object.defineProperty(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var DEFAULT_CASE_SEARCH_RESULTS_ORDERING = '-last_case_application__application__created_at';

var CaseSearchResultsPageStore = (_class = function () {
  function CaseSearchResultsPageStore() {
    _classCallCheck(this, CaseSearchResultsPageStore);

    _initDefineProp(this, 'errorMessage', _descriptor, this);

    _initDefineProp(this, 'isLoading', _descriptor2, this);

    _initDefineProp(this, 'isLoadingMore', _descriptor3, this);

    _initDefineProp(this, 'queryMap', _descriptor4, this);

    _initDefineProp(this, 'headerObject', _descriptor5, this);
  }

  _createClass(CaseSearchResultsPageStore, [{
    key: 'setHeaderObjectFromProps',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(props) {
        var Clients, location, query, PEOPLE_QUERIES, foundPerson;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                Clients = props.Clients, location = props.location, query = location.query, PEOPLE_QUERIES = ['attorney', 'facility_contact', 'contacts', 'provider'], foundPerson = (0, _find3.default)(query, function (value, key) {
                  return PEOPLE_QUERIES.includes(key);
                });

                if (!foundPerson) {
                  _context.next = 7;
                  break;
                }

                _context.next = 4;
                return Clients.people.retrieve(foundPerson);

              case 4:
                this.headerObject = _context.sent;
                _context.next = 17;
                break;

              case 7:
                if (!('lawfirm' in query)) {
                  _context.next = 13;
                  break;
                }

                _context.next = 10;
                return Clients.lawFirms.retrieve(query.lawfirm);

              case 10:
                this.headerObject = _context.sent;
                _context.next = 17;
                break;

              case 13:
                if (!('facility' in query)) {
                  _context.next = 17;
                  break;
                }

                _context.next = 16;
                return Clients.organizations.retrieve(query.facility);

              case 16:
                this.headerObject = _context.sent;

              case 17:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function setHeaderObjectFromProps(_x) {
        return _ref.apply(this, arguments);
      }

      return setHeaderObjectFromProps;
    }()
  }, {
    key: 'setFromProps',
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(props) {
        var CaseStore, location, query;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                CaseStore = props.CaseStore, location = props.location, query = location.query;


                query.ordering = query.ordering || DEFAULT_CASE_SEARCH_RESULTS_ORDERING;

                this.queryMap.clear();
                this.queryMap.merge(query);
                this.errorMessage = null;

                this.isLoading = true;

                _context2.next = 8;
                return this.setHeaderObjectFromProps(props);

              case 8:
                _context2.next = 10;
                return Promise.all([CaseStore.fetchCaseSearchFiltersMeta(this.query), CaseStore.list(this.resultKey, this.query)]);

              case 10:
                this.isLoading = false;

              case 11:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function setFromProps(_x2) {
        return _ref2.apply(this, arguments);
      }

      return setFromProps;
    }()
  }, {
    key: 'loadMore',
    value: function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(CaseStore) {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                this.isLoading = true;
                this.isLoadingMore = true;
                this.errorMessage = null;

                _context3.prev = 3;
                _context3.next = 6;
                return CaseStore.fetchCasesQueryResultsNext(this.resultKey);

              case 6:
                _context3.next = 11;
                break;

              case 8:
                _context3.prev = 8;
                _context3.t0 = _context3['catch'](3);

                this.errorMessage = 'An error occurred.';

              case 11:
                _context3.prev = 11;

                this.isLoading = false;
                this.isLoadingMore = false;
                return _context3.finish(11);

              case 15:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this, [[3, 8, 11, 15]]);
      }));

      function loadMore(_x3) {
        return _ref3.apply(this, arguments);
      }

      return loadMore;
    }()
  }, {
    key: '__reactstandin__regenerateByEval',
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }, {
    key: 'query',
    get: function get() {
      return (0, _mobx.toJS)(this.queryMap);
    }
  }, {
    key: 'resultKey',
    get: function get() {
      return _utils.FormattingUtils.toKey(this.query);
    }
  }]);

  return CaseSearchResultsPageStore;
}(), (_descriptor = _applyDecoratedDescriptor(_class.prototype, 'errorMessage', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, 'isLoading', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, 'isLoadingMore', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, 'queryMap', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return _mobx.observable.map({});
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, 'headerObject', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _applyDecoratedDescriptor(_class.prototype, 'query', [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, 'query'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'resultKey', [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, 'resultKey'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'setHeaderObjectFromProps', [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, 'setHeaderObjectFromProps'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'setFromProps', [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, 'setFromProps'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'loadMore', [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, 'loadMore'), _class.prototype)), _class);
var _default = CaseSearchResultsPageStore;
exports.default = _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(DEFAULT_CASE_SEARCH_RESULTS_ORDERING, 'DEFAULT_CASE_SEARCH_RESULTS_ORDERING', '/app/src/stores/CaseSearchResultsPageStore.js');
  reactHotLoader.register(CaseSearchResultsPageStore, 'CaseSearchResultsPageStore', '/app/src/stores/CaseSearchResultsPageStore.js');
  reactHotLoader.register(_default, 'default', '/app/src/stores/CaseSearchResultsPageStore.js');
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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